const AssetTypesMapping = Object.freeze({
  0: 'image',
  1: 'video',
  2: 'slide',
  3: 'font',
});
export default AssetTypesMapping;